
export const formatFilterValue = (value: string) => 
  value.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');

export const SORT_OPTIONS = [
  'Rating High to Low',
  'Daily Budget Low to High',
  'Population High to Low',
  'Safety Rating High to Low',
  'Internet Speed High to Low',
  'Recently Updated'
];

export const getCostRangeLabel = (avgDailyBudget: number): string => {
  if (avgDailyBudget < 50) return 'Budget (< $50)';
  if (avgDailyBudget < 100) return 'Moderate ($50-$100)';
  return 'Luxury (> $100)';
};

export const formatPriceWithPrecision = (price: number, costType: string): string => {
  // Default precision based on cost type
  if (costType === 'avg_meal_cost' || costType === 'taxi_cost_per_km') {
    return (price || 0).toFixed(1);
  }
  // Use whole numbers for accommodation and daily budget
  return (price || 0).toFixed(0);
};

// Determine if a value is within an actual range of values in dataset
export const isValueInActualRange = (value: number, values: number[]): boolean => {
  if (!values.length) return true;
  const sortedValues = [...values].sort((a, b) => a - b);
  return value >= sortedValues[0] && value <= sortedValues[sortedValues.length - 1];
};

// Get the nearest existing value in the dataset
export const getNearestValue = (value: number, values: number[]): number => {
  if (!values.length) return value;
  
  let nearest = values[0];
  let minDiff = Math.abs(value - nearest);
  
  for (const curr of values) {
    const diff = Math.abs(value - curr);
    if (diff < minDiff) {
      minDiff = diff;
      nearest = curr;
    }
  }
  
  return nearest;
};

// Get appropriate icon and styling for each cost type
export const getCostTypeConfig = (costType: string) => {
  const configs = {
    'avg_daily_budget': {
      icon: 'dollar-sign',
      color: 'green',
      precision: 0,
      defaultMax: 300
    },
    'avg_accommodation_cost': {
      icon: 'hotel',
      color: 'blue',
      precision: 0,
      defaultMax: 500
    },
    'avg_meal_cost': {
      icon: 'utensils',
      color: 'orange',
      precision: 1,
      defaultMax: 100
    },
    'taxi_cost_per_km': {
      icon: 'car',
      color: 'purple',
      precision: 1,
      defaultMax: 20
    }
  };
  
  return configs[costType] || configs['avg_daily_budget'];
};
